import React, { useState, useRef, useEffect } from "react";
import { FaEllipsisV } from "react-icons/fa";

/**
 * Sadece admin kullanıcıya görünen detay sayfası aksiyon menüsü (üç nokta).
 * items: [{ label, onClick, danger?: boolean }]
 */
const AdminDetailMenu = ({ isAdmin, items = [] }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [open]);

  if (!isAdmin || items.length === 0) return null;

  return (
    <div className="relative shrink-0" ref={menuRef}>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
        className="p-2 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 hover:border-gray-300 text-gray-500 hover:text-gray-700 transition-colors"
        title="İşlemler"
        aria-label="İşlemler menüsü"
      >
        <FaEllipsisV className="w-5 h-5" />
      </button>

      {open && (
        <div
          className="absolute right-0 top-full mt-1 py-1 min-w-[180px] bg-white rounded-xl border border-gray-200 shadow-lg z-[1000]"
          role="menu"
        >
          {items.map((item, idx) => (
            <button
              key={idx}
              type="button"
              onClick={() => {
                item.onClick?.();
                setOpen(false);
              }}
              className={`w-full text-left px-4 py-2.5 text-sm font-medium transition-colors ${
                item.danger
                  ? "text-red-600 hover:bg-red-50"
                  : "text-gray-700 hover:bg-gray-50"
              }`}
              role="menuitem"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminDetailMenu;
